import type { ErrorsTranslations } from './errors.translation.pl.ts';

export const errorsTranslations: ErrorsTranslations = {
  basic: {
    title: 'Oops! Something went wrong',
  },
  inactive: {
    title: 'Oops! The link has expired.',
    subMessage: 'Go back to the home page and sign up again.',
  },
  buttons: {
    back: 'Back',
  },
};
